import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { READING_MEMBER_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { AddReadingUserComponent } from './add-reading-user/add-reading-user.component';

@Component({
  selector: 'app-reading-user',
  templateUrl: './reading-user.component.html',
  styleUrls: ['./reading-user.component.scss']
})
export class ReadingUserComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.READING_MEMBERS;
  ACCOUNT_TYPE: any = null;
  NO_AVATAR = 'https://firebasestorage.googleapis.com/v0/b/sysanotta.appspot.com/o/no_image.svg?alt=media&token=f25af902-6c62-47e6-bdf3-48e3b0c6fe8c'

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public store: BookstoreStore,
    public ps: PrintService,
    private storage: FireStorageService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(params => {
      const { id } = params;
      this.ACCOUNT_TYPE = READING_MEMBER_OBJECT[id];
      this.store.fetchMember(this.ACCOUNT_TYPE.key, id === 'training' ? 2 : null)
    })
  }

  ngOnDestroy() {
    const { fetchMemberRef } = this.store;
    fetchMemberRef && fetchMemberRef.unsubscribe();
  }

  onScroll() {
    const { lastVisible } = this.store;
    if (!lastVisible) return;
    this.store.fetchMoreMember(this.ACCOUNT_TYPE.key, this.ACCOUNT_TYPE.key === 5 ? 2 : null)
  }


  create(item?: any) {
    const dialogRef = this.dialog.open(AddReadingUserComponent, {
      data: { STUDENT: item || null, ACCOUNT_TYPE: this.ACCOUNT_TYPE },
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { title: 'Delete Member', memo: 'Member will delete without check any related record. All record that used before not remove from reference.', name: item.name },
      width: '35vw',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        try {
          const { photoFileDetail } = item;
          if (photoFileDetail.filename) {
            this.storage.storageRef(photoFileDetail.filename).delete();
          }
        } catch (error) {
        }
        this.store.deleteMember(item, (success, res) => {
          this.snackBar.open("Member has been deleted successful.", "Done", { duration: 1000 });
        })
      }
    });
  }

}
